// datetime.js — แสดงผลวันที่/เวลาแบบ "เวลาไทย (Asia/Bangkok)" คงที่
// ไม่ขึ้นกับ timezone ของเครื่องผู้ใช้
//
// ทำไมใช้ utcOffset(420) แทน moment-timezone('Asia/Bangkok'):
//   ประเทศไทยใช้ UTC+7 ตลอดทั้งปี ไม่มี DST -> ออฟเซ็ตคงที่ +7 ชม. (420 นาที)
//   จึงไม่ต้องเพิ่ม dependency moment-timezone (ลดขนาด bundle)
//
// ค่าที่รับ (value) ควรเป็น instant จาก backend (คอลัมน์ TIMESTAMP -> ISO string)
// เช่น "2026-06-16T11:42:28.000Z" จะถูกแปลงแสดงเป็นเวลาไทย 18:42

import moment from 'moment';

const BKK_OFFSET_MINUTES = 7 * 60; // +07:00

/**
 * แปลง timestamp ให้แสดงเป็นวันที่+เวลาแบบไทย
 * @param {string|number|Date} value  instant จาก backend
 * @param {string} fmt  รูปแบบ moment (default 'DD/MM/YYYY HH:mm')
 * @returns {string} เช่น "16/06/2026 18:42" หรือ '' ถ้าค่าว่าง/ไม่ถูกต้อง
 */
export function formatDateTimeBKK(value, fmt = 'DD/MM/YYYY HH:mm') {
  if (value === null || value === undefined || value === '') return '';
  const m = moment(value);
  if (!m.isValid()) return '';
  return m.utcOffset(BKK_OFFSET_MINUTES).format(fmt);
}

/**
 * แปลง timestamp ให้แสดงเป็นวันที่ (ไม่มีเวลา) แบบไทย
 * @param {string|number|Date} value
 * @param {string} fmt  default 'DD/MM/YYYY'
 * @returns {string}
 */
export function formatDateBKK(value, fmt = 'DD/MM/YYYY') {
  if (value === null || value === undefined || value === '') return '';
  const m = moment(value);
  if (!m.isValid()) return '';
  return m.utcOffset(BKK_OFFSET_MINUTES).format(fmt);
}

export default { formatDateTimeBKK, formatDateBKK };
